import { render, staticRenderFns } from "./UserTaskReactionReportPage.vue?vue&type=template&id=6ff334b3"
import script from "./UserTaskReactionReportPage.vue?vue&type=script&lang=js"
export * from "./UserTaskReactionReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports